<template>
  <div class="box">
    <div class="container">
      <div class="item line_bottom">
        <div class="left">
          <span>退货单号</span>
          <span>{{orderNumber}}</span>
        </div>
      </div>
      <!-- 收货方式 -->
      <div class="accpet_type line_bottom">
        <span class="type_t">退货方式</span>
        <div class="sent_type">
          <span
            class="line_border_btn"
            v-for="(item,index) in typeList"
            :key="index"
            @click="selectType(item,index)"
            :class="{'active':item.select}"
          >{{item.type}}</span>
        </div>
      </div>
      <div class="get_price">
        <div class="price" v-if="index==1||index==40">
          <div
            class="left line_border_btn"
            v-for="(item1,index) in allList"
            :key="index"
            @click="selectOher(item1,index)"
            :class="{'active':item1.select}"
          >{{item1.type}}</div>
        </div>
        <p class="p_title" v-if="index==40||index==1">退款金额</p>
        <div class="item" @click="showType" v-if="index==30">
          <div class="left">
            <span>原由</span>
            <span class="result_style">{{typeValue}}</span>
          </div>
          <img src="../../../../assets/image/right.png" class="back" />
        </div>
        <div class="p_price line_bottom" v-if="index==40">￥{{price}}</div>
        <input
          type="text"
          class="select_price"
          :placeholder="title"
          v-if="index==1"
          v-model="price"
          @keyup="clearNoNum($event)"
        />
        <div class="result">
          <span class="info">补充</span>
          <textarea class="content1" placeholder="请输入补充内容..." v-model="content"></textarea>
        </div>
        <!-- 图片上传 -->
        <div class="img_list">
          <upload></upload>
        </div>
        <div class="btn" v-if="isOriginHei">
          <span @click="confirm" :class="{'active':change}">确定</span>
        </div>
      </div>
    </div>
    <common-picker
      ref="commonPicker"
      :typeList="resonType"
      :cols="cols1"
      @getTypeValue="getTypeValue"
    ></common-picker>
  </div>
</template>
<script>
import util from "@/utils/common";
import api from "@/service/modules/refund.js";
import commonPicker from "@/components/base/commonPicker";
import upload from "../components/upload";
export default {
  components: {
    commonPicker,
    upload
  },
  data() {
    return {
      title1: "反馈验证结果",
      typeList: [
        { type: "全额退款", value: "40", select: false },
        { type: "部分退款", value: "1", select: false },
        { type: "不予受理", value: "30", select: false }
      ],
      resonType: [],
      cols1: 1,
      flowId: this.$router.currentRoute.query.flowId,
      orderNumber: this.$router.currentRoute.query.number,
      content: "",
      index: "40",
      typeValue: "请选择原由",
      result: [],
      allList: [
        { type: "监理中心垫付", value: "10", select: false },
        { type: "企业直退", value: "20", select: false }
      ],
      code: "", // 退货方式
      code1: "", // 退货原因
      code2: "", //
      price: this.$router.currentRoute.query.price,
      title: "请输入实际退款金额",
      isOriginHei: true,
      documentHeight: document.documentElement.clientHeight, // 默认屏幕高度
      isViewerShow: false,
      viewerIndex: 0,
      Imglist: [],
      isFlag: true,
      isShow: false
    };
  },
  computed: {
    change() {
      if (this.code === "40") {
        if (this.code2 !== "") {
          return true;
        } else {
          return false;
        }
      } else if (this.code && this.code === "1") {
        if (this.code2 !== "" && this.price.trim().length > 0) {
          return true;
        } else {
          return false;
        }
      } else if (this.code && this.code === "30") {
        if (this.code1 !== "" && this.content.trim().length > 0) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  // watch: {
  //     'price' (val) {
  //         let str = val.replace(/,/g, '')
  //         this.price = Number(str).toLocaleString()
  //         if (this.price === '0') {
  //             this.price = ''
  //         }
  //     }
  // },
  mounted() {
    window.onresize = () => {
      return (() => {
        if (this.documentHeight > document.documentElement.clientHeight) {
          this.isOriginHei = false;
        } else {
          this.isOriginHei = true;
        }
      })();
    };
    this.$on("fileUploadData", val => {
      console.log(val);
      this.Imglist = val;
    });
  },
  created() {
    this.getResult();
    this.getResonType();
  },
  methods: {
    clearNoNum(obj) {
      this.price = this.price.replace(/[^\d\.]/g, "");
      this.price = this.price.replace(/^\./g, "");
      this.price = this.price.replace(/\.{2,}/g, ".");
      this.price = this.price
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      this.price = this.price.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
    },
    getResonType() {
      var type = util.getJsonLocal("configList").WHEREFORE;
      let list = [];
      type.map((item, index) => {
        list.push({ text: item.name, value: index, code: item.code });
      });
      this.resonType.push(list);
    },
    getType() {
      var list = util.getJsonLocal("configList").FEEDBACK_TYPE;
      list.map((item, index) => {
        var obj = { type: item.name, value: item.code, select: false };
        this.typeList.push(obj);
      });
    },
    getALL() {
      var list = util.getJsonLocal("configList").PAYMENT_METHOD;
      list.map((item, index) => {
        var obj = { type: item.name, value: item.code, select: false };
        this.allList.push(obj);
      });
    },
    getResult() {
      var type = util.getJsonLocal("configList").WHEREFORE;
      let list = [];
      type.map((item, index) => {
        list.push({ text: item.name, value: index, code: item.code });
      });
      this.result.push(list);
    },
    selectOher(item, index) {
      // 企业还是垫付
      this.allList.map((item, index) => {
        this.$set(this.allList[index], "select", false);
      });
      this.$set(this.allList[index], "select", true);
      this.code2 = item.value;
    },
    showType() {
      this.$refs.commonPicker.showPicker();
    },
    getTypeValue(value) {
      //
      this.typeValue = value[0].text;
      this.code1 = value[0].code;
    },
    confirm() {
      if (this.code === "") {
        this.$Toast({
          message: "请选择退款方式"
        });
      } else if (
        (this.code === "1" || this.code === "40") &&
        this.code2 === ""
      ) {
        this.$Toast({
          message: "请选择企业直退还是垫付"
        });
      } else if (this.code === "1" && this.price.trim().length === 0) {
        this.$Toast({
          message: "请输入退款金额~"
        });
      } else if (this.code === "30" && this.typeValue === "请选择原由") {
        this.$Toast({
          message: "请选择退款原因~"
        });
      } else if (
        this.code === 30 &&
        this.typeValue !== "请选择原由" &&
        this.content.trim().length === 0
      ) {
        this.$Toast({
          message: "请填写补充原因~"
        });
      } else {
        if (this.isFlag) {
          this.getVerify();
          this.isFlag = false;
        }
      }
    },
    selectType(item, index) {
      // 退货方式
      this.typeList.map((item, index) => {
        this.$set(this.typeList[index], "select", false);
      });
      this.$set(this.typeList[index], "select", true);
      this.code = item.value;
      this.index = item.value;
      if (this.code === "40") {
        // 全部退款
        this.price = this.$router.currentRoute.query.price;
        this.code1 = "";
        this.changeState();
      } else if (this.code === "1") {
        // 部分退款
        this.price = "";
        this.title = "请输入实际退款金额";
        this.code1 = "";
        this.changeState();
      } else if (this.code === "30") {
        // 拒绝退款
        this.title = "请输入实际退款金额";
        this.price = "";
        this.code2 = "";
        this.content = "";
        this.changeState();
      }
    },
    changeState() {
      this.allList.map((item, index) => {
        this.$set(this.allList[index], "select", false);
      });
    },
    // 提交
    getVerify() {
      let img = this.Imglist.join(",");
      api
        .verify({
          flowId: this.flowId,
          feedback: this.code,
          refundAmount: this.price,
          refundType: this.code2,
          content: this.content,
          wherefore: this.code1,
          attachments: img
        })
        .then(res => {
          if (res.ret === 0) {
            this.isFlag = false;
            this.$Toast({
              message: "反馈成功~"
            });
            this.isOriginHei = false;
            setTimeout(() => {
              this.$router.back();
            }, 1500);
          } else {
            this.$Toast({
              message: res.msg
            });
          }
        });
    }
  }
};
</script>
<style  lang="less" scoped>
.box {
  width: 100%;
  .container {
    width: 100%;
    height: 100%;
    padding: 0px 12px 70px 12px;
    .item {
      display: flex;
      display: -webkit-flex;
      padding: 24px 0;
      justify-content: space-between;
      -webkit-justify-content: space-between;
      align-items: center;
      .left {
        display: flex;
        span:nth-child(2) {
          margin-left: 20px;
        }
        span {
          font-size: 14px;
          color: #333333;
        }
        .result_style {
          color: #d4d4d4;
        }
      }
      .back {
        width: 6px;
        height: 12px;
      }
    }
    .accpet_type {
      padding: 23px 0;
      .type_t {
        display: inline-block;
        font-size: 14px;
        color: #333333;
      }
      .sent_type {
        margin-top: 12px;
        span {
          display: inline-block;
          width: 92px;
          height: 30px;
          // border:1px solid @base-color;
          border-color: @base-color;
          border-radius: 1px;
          text-align: center;
          line-height: 30px;
          color: @base-color;
          font-size: 15px;
        }
        span:nth-child(2) {
          margin-left: 12px;
        }
        span:nth-child(3) {
          margin-left: 12px;
        }
        span:nth-child(4) {
          margin-top: 12px;
        }
        .active {
          background-color: @base-color;
          color: #fff;
          border: 1px solid @base-color;
        }
      }
    }
    .get_price {
      .price {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        margin-top: 23px;
        .left {
          // width:92px;
          padding: 0 20px;
          height: 30px;
          text-align: center;
          line-height: 30px;
          font-size: 15px;
          color: @base-color;
          border-radius: 1px;
          margin-right: 12px;
        }
        .active {
          background-color: @base-color;
          color: #fff;
          border: 1px solid @base-color;
        }
      }
      .p_title {
        color: #333333;
        font-size: 14px;
        margin-top: 24px;
      }
      .p_price {
        padding: 27px 0;
        font-size: 26px;
        color: #4a4a4a;
        font-family: "DIN-Bold,DIN";
        font-weight: bold;
      }
      .select_price {
        width: 100%;
        border: 0;
        outline: none;
        font-size: 15px;
        // color:#D4D4D4;
        padding: 23px 0;
        border-bottom: 1px solid #eeeeee;
      }
      .result {
        .info {
          display: inline-block;
          padding: 22px 0 12px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .content1 {
          width: 100%;
          height: 180px;
          background-color: #f9f9f9;
          border: 0;
          outline: none;
          resize: none;
          padding: 15px 0 0 15px;
          box-sizing: border-box;
          color: #000 !important;
          border-radius: 3px;
          font-size: 15px;
          line-height: 21px;
        }
      }
      .img_list {
        width: 100%;
        box-sizing: border-box;
        margin-top: 20px;
        .item1 {
          width: 70px;
          height: 70px;
          display: inline-block;
          position: relative;
          margin-left: 10px;
          margin-top: 20px;
          img {
            width: 100%;
            height: 100%;
          }
          .delect {
            width: 20px;
            height: 20px;
            position: absolute;
            right: 0;
            top: 0;
            background: rgba(0, 0, 0, 0.4);
            color: #fff;
            font-size: 20px;
            text-align: center;
            line-height: 20px;
            z-index: 2;
          }
        }
        .item_active {
          position: relative;
          top: 0px;
        }
      }
      .btn {
        width: 100%;
        height: 70px;
        padding: 0 12px;
        position: fixed;
        left: 0;
        bottom: -12px;
        background-color: #fff;
        z-index: 2;
        span {
          width: 100%;
          height: 50px;
          display: inline-block;
          background-color: @base-color;
          opacity: 0.5;
          text-align: center;
          line-height: 50px;
          color: 16px;
          font-size: 16px;
          color: #fff;
          border-radius: 3px;
        }
        .active {
          opacity: 1;
        }
      }
    }
  }
}
</style>
<style  lang="less">
</style>
